import { useLogout } from '../../api/generated/insights';

const useLogoutHelper = (onLogout?: () => void) => {
  return useLogout({
    mutation: {
      onSettled: () => {
        if (onLogout) {
          onLogout();
        }
      },
    },
  });
};

export default useLogoutHelper;
